const LOCALE_BY_LANG = { it: "it-IT", en: "en-GB", de: "de-DE", fr: "fr-FR", es: "es-ES", pt: "pt-PT", nl: "nl-NL", ja: "ja-JP", zh: "zh-CN", ar: "ar-EG", hi: "hi-IN", ko: "ko-KR" };
const SYMBOL_TO_CODE = { "€": "eur", "$": "usd", "£": "gbp", "CHF": "chf", "zł": "pln", "Kč": "czk", "Ft": "huf", "lei": "ron", "лв": "bgn", "CA$": "cad", "A$": "aud", "NZ$": "nzd", "¥": "jpy", "HK$": "hkd", "S$": "sgd", "₩": "krw", "₹": "inr", "AED": "aed", "SAR": "sar", "₺": "try", "₪": "ils", "R": "zar", "MX$": "mxn", "R$": "brl", "AR$": "ars", "฿": "thb", "RM": "myr", "₱": "php", "Rp": "idr", "₫": "vnd", "MAD": "mad", "kr": "sek" };

const toCode = (c) => {
  if (!c) return "eur";
  if (/^[a-zA-Z]{3}$/.test(c) && !SYMBOL_TO_CODE[c]) return c.toLowerCase();
  return SYMBOL_TO_CODE[c] || (/^[a-zA-Z]{3}$/.test(c) ? c.toLowerCase() : "eur");
};

const uiLang = () => (localStorage.getItem("menuone_ui_lang") || "it").toLowerCase().slice(0, 2);

// `currency` may be an ISO code ("usd") or a symbol ("€"); `lang` defaults to the dashboard/browser language.
export const fmtMoney = (amount, currency = "eur", lang = uiLang()) => {
  const value = Number(amount) || 0;
  const locale = LOCALE_BY_LANG[lang] || lang || "it-IT";
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency: toCode(currency).toUpperCase() }).format(value);
  } catch {
    return `${value.toFixed(2)} ${currency}`;
  }
};
